export const Theme = {
    Light: "light" as const,
    Dark: "dark" as const,
};

export interface AppConfig {
    profile?: {
        id?: string
        displayName?: string
        firstName?: string
        lastName?: string
        photoURL?: string
        email?: string
        avatar?: string
    }
    theme?: {
        isDarkTheme?: boolean
        isRtl?: boolean
        name?: string
    },
    scene?: string
};